import aws from "./images/icons8-amazon-web-services.svg"
import java from "./images/icons8-java.svg"
import react from "./images/icons8-react.svg"
import node from "./images/icons8-nodejs.svg"
import mongo from "./images/icons8-mongodb.svg"
import native from "./images/icons8-react-native.svg"
import docker from "./images/icons8-docker.svg"
import js from "./images/icons8-javascript.svg"

export const TECHS = {
  JAVASCRIPT: js,
  REACT: react,
  NODE: node,
  AWS: aws,
  JAVA: java,
  REACT_NATIVE: native,
  MONGO: mongo,
  DOCKER: docker,
}
